module.exports = __webpack_public_path__ + "static/bg-about-value-7e9cca9703ec61d66f572eda666d929a.jpg";